import { useState, useEffect } from 'react'
import { createClient } from '@supabase/supabase-js'
import axios from 'axios'
import { programarNotificacionesDiarias } from '../utils/notificacionesDiarias'
import Curriculo from './Curriculo'
import PaginaLeccion from './PaginaLeccion'
import ClasesVivo from './ClasesVivo'
import SalaClaseVivo from './SalaClaseVivo'
import Diccionario from './Diccionario'
import VideoForos from './VideoForos'
import Retos from './Retos'
import EduNovaJuegos from './EduNovaJuegos'
import MiProgreso from './MiProgreso'
import Ranking from './Ranking'
import Insignias from './Insignias'
import Worksheets from './Worksheets'
import Lecturas from './Lecturas'

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
)

const API = process.env.REACT_APP_API_URL

const COLORES = {
  A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6',
  B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}
const EMOJIS = {
  A1:'🌱', A2:'🚀', B1:'⚡', B2:'🔥', C1:'💎', C2:'👑'
}

const NAV = [
  { id:'inicio',      ic:'🏠', es:'Inicio',            en:'Home'              },
  { id:'curriculo',   ic:'📚', es:'Curriculo',         en:'Curriculum'        },
  { id:'clases',      ic:'🎥', es:'Clases en vivo',    en:'Live Classes'      },
  { id:'foros',       ic:'🎙', es:'VideoForos',        en:'VideoForums'       },
  { id:'retos',       ic:'🔥', es:'Retos diarios',     en:'Daily Challenges'  },
  { id:'progreso',    ic:'📊', es:'Mi progreso',       en:'My Progress'       },
  { id:'insignias',   ic:'🏅', es:'Insignias',         en:'Badges'            },
  { id:'ranking',     ic:'🏆', es:'Ranking',           en:'Leaderboard'       },
  { id:'diccionario', ic:'🔍', es:'Diccionario',       en:'Dictionary'        },
  { id:'juegos',      ic:'🎮', es:'EduNova Juegos',    en:'EduNova Games'     },
  { id:'worksheets',  ic:'📄', es:'Worksheets',        en:'Worksheets'        },
  { id:'lecturas',    ic:'📖', es:'Lecturas',          en:'Reading'           },
]

const TEXTOS = {
  es: {
    hola: 'Hola!', bienvenido: 'Bienvenido a EspañolGo', xpTotales: 'XP totales',
    diasRacha: 'Dias de racha', leccionesCompletadas: 'Lecciones completadas',
    palabrasGuardadas: 'Palabras guardadas', retosCompletados: 'Retos completados',
    tuCurriculo: 'Tu curriculo A1-C2', verTodo: 'Ver todo →', cargando: 'Cargando...',
    retosHoy: 'Retos de hoy', verTodos: 'Ver todos →', retoDiario: 'Reto diario disponible',
    retoDesc: 'Aprende slangs bogotanos y gana insignias exclusivas', empezar: 'Empezar →',
    misInsignias: 'Mis Insignias', coleccionaInsignias: 'Colecciona insignias',
    insigniasDesc: 'Gana insignias completando retos, lecciones y mas', ver: 'Ver →',
    juegosTitulo: 'EduNova Juegos', aprendeJugando: 'Aprende jugando',
    juegosDesc: 'Trivia colombiana, verdadero o falso, conjugacion y mas', jugar: 'Jugar →',
    lecturasTitulo: 'Lecturas', lecturasSubt: 'Cuentos y noticias en español',
    lecturasDesc: 'Practica tu comprension lectora por nivel',
    worksheetsTitulo: 'Worksheets', worksheetsSubt: '20 worksheets disponibles',
    worksheetsDesc: 'Hojas de práctica para cada nivel — A1 a C1. Descarga y practica sin conexión.',
    rankingTitulo: 'Ranking', competeTitulo: 'Compite con otros estudiantes',
    competeDesc: 'Gana puntos con lecciones, examenes e insignias', verRanking: 'Ver ranking →',
    cambiarAvatar: 'Cambiar avatar', cerrarSesion: 'Cerrar sesion',
    seccionProximamente: 'Esta seccion estara disponible proximamente.'
  },
  en: {
    hola: 'Hello!', bienvenido: 'Welcome to EspañolGo', xpTotales: 'Total XP',
    diasRacha: 'Streak days', leccionesCompletadas: 'Lessons completed',
    palabrasGuardadas: 'Saved words', retosCompletados: 'Challenges completed',
    tuCurriculo: 'Your A1-C2 curriculum', verTodo: 'See all →', cargando: 'Loading...',
    retosHoy: "Today's challenges", verTodos: 'See all →', retoDiario: 'Daily challenge available',
    retoDesc: 'Learn Bogota slang and earn exclusive badges', empezar: 'Start →',
    misInsignias: 'My Badges', coleccionaInsignias: 'Collect badges',
    insigniasDesc: 'Earn badges by completing challenges, lessons and more', ver: 'View →',
    juegosTitulo: 'EduNova Games', aprendeJugando: 'Learn by playing',
    juegosDesc: 'Colombian trivia, true or false, conjugation and more', jugar: 'Play →',
    lecturasTitulo: 'Reading', lecturasSubt: 'Short stories and news in Spanish',
    lecturasDesc: 'Practice your reading comprehension by level',
    worksheetsTitulo: 'Worksheets', worksheetsSubt: '20 worksheets available',
    worksheetsDesc: 'Practice sheets for every level — A1 to C1. Download and practice offline.',
    rankingTitulo: 'Leaderboard', competeTitulo: 'Compete with other students',
    competeDesc: 'Earn points with lessons, tests and badges', verRanking: 'See leaderboard →',
    cambiarAvatar: 'Change avatar', cerrarSesion: 'Log out',
    seccionProximamente: 'This section will be available soon.'
  }
}

const BANDERAS = ['🇨🇴','🇨🇦','🇺🇸','🇧🇷','🇯🇵','🇨🇳','🇬🇧','🇫🇷','🇵🇹']

const EMOJIS_AVATAR = [
  '😀','🧑‍💻','🧑‍🎓','🦸','🧑‍🎨','👩‍🚀','🧑‍🍳','🧑‍🏫',
  '🐱','🐶','🦊','🐼','🦁','🐨','🐸','🦉',
  '🐧','🦄','🌟','🔥','🎯','📚','🎸','⚽'
]

/* Hook simple para detectar si estamos en tamaño movil */
function useEsMovil() {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  )
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 820px)')
    const handler = e => setEsMovil(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return esMovil
}

/* Avatar del usuario: muestra foto si existe, si no el emoji elegido, si no la inicial del email */
function AvatarUsuario({ avatarUrl, avatarEmoji, email, size = 36, onClick }) {
  const base = {
    width: size, height: size, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: size * 0.42, fontWeight: 800, color: '#fff',
    marginBottom: '6px', overflow: 'hidden', flexShrink: 0,
    cursor: onClick ? 'pointer' : 'default',
    border: onClick ? '2px solid rgba(255,255,255,0.25)' : 'none',
    position: 'relative'
  }

  const contenido = avatarUrl
    ? <img src={avatarUrl} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    : avatarEmoji
      ? avatarEmoji
      : email?.[0]?.toUpperCase()

  return (
    <div style={{ ...base, background: avatarUrl ? 'var(--gris-borde)' : 'var(--naranja)' }} onClick={onClick} title={onClick ? 'Cambiar avatar / Change avatar' : undefined}>
      {contenido}
    </div>
  )
}

/* Modal para elegir/cambiar avatar - disponible para cualquier usuario en cualquier momento */
function ModalAvatar({ usuario, avatarActualEmoji, avatarActualUrl, idioma, onCerrar, onGuardado }) {
  const [tipoAvatar,   setTipoAvatar]   = useState(avatarActualUrl ? 'foto' : 'emoji')
  const [emojiElegido, setEmojiElegido] = useState(avatarActualEmoji || EMOJIS_AVATAR[0])
  const [archivoFoto,  setArchivoFoto]  = useState(null)
  const [previewFoto,  setPreviewFoto]  = useState(avatarActualUrl || null)
  const [guardando,    setGuardando]    = useState(false)
  const [error,        setError]        = useState('')
  // La grilla de emojis empieza cerrada: solo se despliega cuando el
  // usuario le da clic a "Seleccionar emoji", en vez de mostrar los 24 de
  // una vez.
  const [emojiGridAbierto, setEmojiGridAbierto] = useState(false)

  const t = idioma === 'en'
    ? { titulo:'Change avatar', emoji:'😀 Choose Emoji', foto:'📷 Upload Photo', preview:'Preview',
        cambiarFoto:'Change photo', seleccionarFoto:'Select photo', limite:'JPG or PNG, max 3MB',
        guardar:'Save avatar', guardando:'Saving...', errorTam:'Image cannot exceed 3MB',
        errorFoto:'Select a photo first', errorGuardar:'Could not save avatar. Try again.',
        elegirEmoji:'Choose emoji', ocultarEmoji:'Hide' }
    : { titulo:'Cambiar avatar', emoji:'😀 Elegir Emoji', foto:'📷 Subir Foto', preview:'Vista previa',
        cambiarFoto:'Cambiar foto', seleccionarFoto:'Seleccionar foto', limite:'JPG o PNG, maximo 3MB',
        guardar:'Guardar avatar', guardando:'Guardando...', errorTam:'La imagen no puede pesar mas de 3MB',
        errorFoto:'Selecciona una foto primero', errorGuardar:'No se pudo guardar el avatar. Intenta de nuevo.',
        elegirEmoji:'Seleccionar emoji', ocultarEmoji:'Ocultar' }

  function handleSeleccionarFoto(e) {
    const file = e.target.files[0]
    if (!file) return
    if (file.size > 3 * 1024 * 1024) { setError(t.errorTam); return }
    setArchivoFoto(file)
    setPreviewFoto(URL.createObjectURL(file))
    setError('')
  }

  async function guardarAvatar() {
    setGuardando(true); setError('')
    try {
      let avatarUrl = null

      if (tipoAvatar === 'foto') {
        if (archivoFoto) {
          const extension = archivoFoto.name.split('.').pop()
          const rutaArchivo = usuario.id + '/avatar.' + extension
          const { error: errorSubida } = await supabase.storage
            .from('avatars')
            .upload(rutaArchivo, archivoFoto, { upsert: true })
          if (errorSubida) throw errorSubida
          const { data: urlData } = supabase.storage.from('avatars').getPublicUrl(rutaArchivo)
          avatarUrl = urlData.publicUrl + '?t=' + Date.now()
        } else if (avatarActualUrl) {
          avatarUrl = avatarActualUrl
        } else {
          setError(t.errorFoto); setGuardando(false); return
        }
      }

      await axios.put(API + '/progreso/actualizar-avatar', {
        usuario_id: usuario.id,
        avatar_emoji: tipoAvatar === 'emoji' ? emojiElegido : null,
        avatar_url:   tipoAvatar === 'foto'  ? avatarUrl    : null
      })

      onGuardado()
    } catch (err) {
      console.error(err)
      setError(t.errorGuardar)
    }
    setGuardando(false)
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
      onClick={onCerrar}>
      <div style={{ background:'#fff', borderRadius:18, maxWidth:420, width:'100%', padding:28, maxHeight:'90vh', overflowY:'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:18 }}>
          <h3 style={{ fontSize:18, fontWeight:800, color:'#1A1A2E' }}>{t.titulo}</h3>
          <button onClick={onCerrar} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'#9CA3AF' }}>✕</button>
        </div>

        {error && (
          <div style={{ background:'#FEF2F2', color:'#991B1B', padding:'8px 12px', borderRadius:8, fontSize:13, marginBottom:14 }}>{error}</div>
        )}

        <div style={{ display:'flex', gap:8, marginBottom:16 }}>
          <button onClick={() => setTipoAvatar('emoji')}
            style={{ flex:1, padding:'9px', borderRadius:8, border:'1.5px solid ' + (tipoAvatar==='emoji' ? '#1B3A8C' : '#E2E6F0'),
              background: tipoAvatar==='emoji' ? '#1B3A8C' : '#fff', color: tipoAvatar==='emoji' ? '#fff' : '#374151',
              fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
            {t.emoji}
          </button>
          <button onClick={() => setTipoAvatar('foto')}
            style={{ flex:1, padding:'9px', borderRadius:8, border:'1.5px solid ' + (tipoAvatar==='foto' ? '#1B3A8C' : '#E2E6F0'),
              background: tipoAvatar==='foto' ? '#1B3A8C' : '#fff', color: tipoAvatar==='foto' ? '#fff' : '#374151',
              fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
            {t.foto}
          </button>
        </div>

        {tipoAvatar === 'emoji' ? (
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom: emojiGridAbierto ? 14 : 0 }}>
              <div style={{ width:56, height:56, borderRadius:'50%', background:'#F8FAFF', border:'2px solid #1B3A8C', display:'flex', alignItems:'center', justifyContent:'center', fontSize:28, flexShrink:0 }}>
                {emojiElegido}
              </div>
              <button type="button" onClick={() => setEmojiGridAbierto(v => !v)}
                style={{ padding:'8px 14px', borderRadius:8, border:'1.5px solid #1B3A8C', background:'#fff', color:'#1B3A8C', fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
                {emojiGridAbierto ? t.ocultarEmoji : t.elegirEmoji}
              </button>
            </div>
            {emojiGridAbierto && (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(8,1fr)', gap:6 }}>
                {EMOJIS_AVATAR.map(emoji => (
                  <button key={emoji} onClick={() => { setEmojiElegido(emoji); setEmojiGridAbierto(false) }}
                    style={{ width:'100%', aspectRatio:'1', borderRadius:8, border:'1.5px solid ' + (emojiElegido===emoji ? '#1B3A8C' : '#E2E6F0'),
                      background: emojiElegido===emoji ? '#EEF2FF' : '#fff', fontSize:18, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {emoji}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div style={{ textAlign:'center' }}>
            {previewFoto ? (
              <img src={previewFoto} alt="Preview" style={{ width:90, height:90, borderRadius:'50%', objectFit:'cover', border:'2px solid #1B3A8C', marginBottom:12 }} />
            ) : (
              <div style={{ width:90, height:90, borderRadius:'50%', background:'#E2E6F0', margin:'0 auto 12px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:30, color:'#9CA3AF' }}>
                📷
              </div>
            )}
            <label style={{ display:'inline-block', padding:'9px 18px', background:'#fff', border:'1.5px solid #1B3A8C', color:'#1B3A8C', borderRadius:8, fontSize:13, fontWeight:700, cursor:'pointer' }}>
              {previewFoto ? t.cambiarFoto : t.seleccionarFoto}
              <input type="file" accept="image/*" onChange={handleSeleccionarFoto} style={{ display:'none' }} />
            </label>
            <div style={{ fontSize:11, color:'#9CA3AF', marginTop:6 }}>{t.limite}</div>
          </div>
        )}

        <button onClick={guardarAvatar} disabled={guardando}
          style={{ width:'100%', marginTop:22, padding:'12px', background:'#1B3A8C', color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
          {guardando ? t.guardando : t.guardar}
        </button>
      </div>
    </div>
  )
}

/* Wordmark EspañolGo + logo EduNova, clickeable para volver al inicio */
function MarcaEspanolGo({ onClick, size = 'normal' }) {
  const fontSize = size === 'small' ? 16 : 17
  return (
    <button onClick={onClick} title="EspañolGo — inicio / home"
      style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', alignItems:'center', gap:8, textAlign:'left' }}>
      <img src="/edunova-logo.png" alt="EduNova"
        style={{ width: size === 'small' ? 22 : 26, height: size === 'small' ? 22 : 26, objectFit:'contain', flexShrink:0 }} />
      <div style={{ fontSize, fontWeight:900, letterSpacing:'-0.5px' }}>
        <span style={{ color:'#FFD700' }}>Esp</span>
        <span style={{ color:'#7BA7E8' }}>añ</span>
        <span style={{ color:'#FF8A8A' }}>olGo</span>
      </div>
    </button>
  )
}

export default function Dashboard({ usuario, onLogout }) {
  const [pagina,        setPagina]        = useState('inicio')
  const [claseEnVideo,  setClaseEnVideo]  = useState(null) // id de la clase cuya videollamada esta abierta
  const [niveles,       setNiveles]       = useState([])
  const [cargando,      setCargando]      = useState(true)
  const [leccionActiva, setLeccionActiva] = useState(null)
  const [curriculoKey,  setCurriculoKey]  = useState(0)
  const [notifInsignia, setNotifInsignia] = useState(null)
  const [stats,         setStats]         = useState(null)
  const [palabrasCount, setPalabrasCount] = useState(0)
  const [modalAvatar,   setModalAvatar]   = useState(false)
  const [menuAbierto,   setMenuAbierto]   = useState(false)
  const [idioma,        setIdioma]        = useState('es') // 'es' | 'en'
  const esMovil = useEsMovil()
  const t = TEXTOS[idioma]

  useEffect(() => {
    axios.get(API + '/curriculo/niveles')
      .then(r => setNiveles(r.data.datos || []))
      .finally(() => setCargando(false))
    if (usuario?.id) {
      recargarStats()
      axios.get(API + '/curriculo/diccionario/guardadas/' + usuario.id)
        .then(r => setPalabrasCount(r.data.datos?.length || 0))
        .catch(() => setPalabrasCount(0))
    }
  }, [usuario])

  // Notificaciones diarias de la app de celular: momento de calma (7 a. m.)
  // y mini noticia en espanol (6 p. m.). En la pagina web no hace nada.
  useEffect(() => {
    if (usuario?.id) programarNotificacionesDiarias()
  }, [usuario])

  useEffect(() => {
    if (pagina === 'inicio' && usuario?.id) {
      recargarStats()
      axios.get(API + '/curriculo/diccionario/guardadas/' + usuario.id)
        .then(r => setPalabrasCount(r.data.datos?.length || 0))
        .catch(() => setPalabrasCount(0))
    }
  }, [pagina])

  function recargarStats() {
  if (usuario?.id) {
    axios.get(API + '/progreso/estadisticas/' + usuario.id, {
      headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
      params: { t: Date.now() }
    })
      .then(r => setStats(r.data.datos ? { ...r.data.datos, avatar_emoji: r.data.avatar_emoji, avatar_url: r.data.avatar_url } : null))
      .catch(() => setStats(null))
  }
}

  function volverAlCurriculo() {
    setCurriculoKey(k => k + 1)
    setPagina('curriculo')
  }

  function handleNuevaInsignia(nuevas) {
    if (!nuevas || nuevas.length === 0) return
    setNotifInsignia(nuevas[0])
    setTimeout(() => setNotifInsignia(null), 5000)
  }

  function irAPagina(id) {
    setPagina(id)
    if (esMovil) setMenuAbierto(false)
  }

  function unirseAClase(claseId) {
    setClaseEnVideo(claseId)
    irAPagina('sala-clase')
  }

  function renderContenido() {

    if (pagina === 'leccion') return (
      <PaginaLeccion
        leccionId={leccionActiva?.id || leccionActiva}
        unidadId={leccionActiva?.unidadId}
        unidadNombre={leccionActiva?.unidadNombre}
        esUltimaLeccion={leccionActiva?.esUltimaLeccion}
        usuario={usuario}
        onVolver={volverAlCurriculo}
        onXpGanado={recargarStats}
      />
    )

    if (pagina === 'clases')      return <ClasesVivo    usuario={usuario} idioma={idioma} onUnirse={unirseAClase} />
    if (pagina === 'sala-clase')  return <SalaClaseVivo usuarioId={usuario?.id} claseId={claseEnVideo} idioma={idioma} onSalir={() => irAPagina('clases')} />
    if (pagina === 'foros')       return <VideoForos    usuario={usuario} idioma={idioma} />
    if (pagina === 'retos')       return <Retos         usuario={usuario} idioma={idioma} onXpGanado={recargarStats} />
    if (pagina === 'diccionario') return <Diccionario   usuario={usuario} idioma={idioma} />
    if (pagina === 'juegos')      return <EduNovaJuegos usuario={usuario} idioma={idioma} onXpGanado={recargarStats} />
    if (pagina === 'progreso')    return <MiProgreso    usuario={usuario} idioma={idioma} />
    if (pagina === 'ranking')     return <Ranking       usuario={usuario} idioma={idioma} />
    if (pagina === 'insignias')   return <Insignias     usuario={usuario} idioma={idioma} onNuevaInsignia={handleNuevaInsignia} />
    if (pagina === 'worksheets')  return <Worksheets    usuario={usuario} idioma={idioma} />
    if (pagina === 'lecturas')    return <Lecturas      usuario={usuario} idioma={idioma} />

    if (pagina === 'curriculo') return (
      <Curriculo key={curriculoKey} usuario={usuario} idioma={idioma}
        onIniciarLeccion={(leccionId, extras) => {
          setLeccionActiva({ id: leccionId, ...extras })
          setPagina('leccion')
        }} />
    )

    if (pagina === 'inicio') {
      return (
        <div style={{ animation:'fadeIn .3s ease both' }}>
          <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'28px', flexWrap:'wrap', gap:12 }}>
            <div>
              <h1 style={{ fontSize: esMovil ? '22px' : '26px', fontWeight:800 }}>{t.hola} 👋</h1>
              <p style={{ color:'var(--gris-texto)', marginTop:'4px', fontSize:'14px', wordBreak:'break-all' }}>
                {usuario?.email} · {t.bienvenido}
              </p>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize: esMovil ? '22px' : '28px', fontWeight:800, color:'var(--azul)' }}>
                ⚡ {(stats?.xp_total || 0).toLocaleString()}
              </div>
              <div style={{ fontSize:'11px', color:'var(--gris-texto)' }}>{t.xpTotales}</div>
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns: esMovil ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap:'12px', marginBottom:'32px' }}>
            {[
              { ic:'🔥', num: stats?.racha_dias            || 0, label:t.diasRacha           },
              { ic:'📚', num: stats?.lecciones_completadas || 0, label:t.leccionesCompletadas },
              { ic:'📖', num: palabrasCount,                     label:t.palabrasGuardadas    },
              { ic:'🏆', num: stats?.retos_completados     || 0, label:t.retosCompletados     }
            ].map((s, i) => (
              <div key={i} style={{ background:'#fff', border:'1px solid var(--gris-borde)', borderRadius:'14px', padding:'18px 12px', textAlign:'center' }}>
                <div style={{ fontSize:'24px', marginBottom:'6px' }}>{s.ic}</div>
                <div style={{ fontSize:'26px', fontWeight:800, color:'var(--azul)' }}>{s.num}</div>
                <div style={{ fontSize:'12px', color:'var(--gris-texto)', marginTop:'2px' }}>{s.label}</div>
              </div>
            ))}
          </div>

          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'16px' }}>
            <h2 style={{ fontSize:'18px', fontWeight:700 }}>{t.tuCurriculo}</h2>
            <button onClick={() => irAPagina('curriculo')}
              style={{ background:'none', border:'1.5px solid var(--azul)', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'var(--azul)', fontWeight:600 }}>
              {t.verTodo}
            </button>
          </div>

          {cargando ? (
            <div style={{ textAlign:'center', padding:'40px', color:'var(--gris-texto)' }}>{t.cargando}</div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(3,1fr)', gap:'14px' }}>
              {niveles.map(n => (
                <div key={n.id} onClick={() => irAPagina('curriculo')}
                  style={{ background:'#fff', border:'1px solid var(--gris-borde)', borderRadius:'14px', padding:'20px', cursor:'pointer', transition:'all .18s ease' }}
                  onMouseOver={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 4px 16px rgba(27,58,140,.10)' }}
                  onMouseOut={e =>  { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'12px' }}>
                    <span style={{ fontSize:'22px' }}>{EMOJIS[n.id]}</span>
                    <div>
                      <span style={{ background:COLORES[n.id], color:'#fff', fontSize:'11px', fontWeight:800, padding:'2px 9px', borderRadius:'999px' }}>{n.id}</span>
                      <div style={{ fontSize:'14px', fontWeight:700, marginTop:'2px' }}>{n.nombre}</div>
                    </div>
                    <span style={{ marginLeft:'auto', fontSize:'13px', fontWeight:700, color:'var(--azul)' }}>0%</span>
                  </div>
                  <div style={{ height:'6px', background:'var(--gris-borde)', borderRadius:'999px', overflow:'hidden', marginBottom:'8px' }}>
                    <div style={{ width:'0%', height:'100%', background:COLORES[n.id], borderRadius:'999px' }} />
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:'11px', color:'var(--gris-texto)' }}>
                    <span>{n.horas_totales}h</span>
                    <span>⚡ {n.xp_total.toLocaleString()} XP</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ marginTop:32 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>🔥 {t.retosHoy}</h2>
              <button onClick={() => irAPagina('retos')}
                style={{ background:'none', border:'1.5px solid #7C3AED', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#7C3AED', fontWeight:600 }}>
                {t.verTodos}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#4F46E5,#7C3AED)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('retos')}>
              <span style={{ fontSize:48 }}>🏆</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.retoDiario}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.retoDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.empezar}
              </div>
            </div>
          </div>

          <div style={{ marginTop:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>🏅 {t.misInsignias}</h2>
              <button onClick={() => irAPagina('insignias')}
                style={{ background:'none', border:'1.5px solid #F59E0B', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#F59E0B', fontWeight:600 }}>
                {t.verTodos}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('insignias')}>
              <span style={{ fontSize:48 }}>🏅</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.coleccionaInsignias}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.insigniasDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.ver}
              </div>
            </div>
          </div>

          <div style={{ marginTop:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>🎮 {t.juegosTitulo}</h2>
              <button onClick={() => irAPagina('juegos')}
                style={{ background:'none', border:'1.5px solid #059669', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#059669', fontWeight:600 }}>
                {t.jugar}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#065F46,#059669)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('juegos')}>
              <span style={{ fontSize:48 }}>🎮</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.aprendeJugando}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.juegosDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.jugar}
              </div>
            </div>
          </div>

          <div style={{ marginTop:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>📖 {t.lecturasTitulo}</h2>
              <button onClick={() => irAPagina('lecturas')}
                style={{ background:'none', border:'1.5px solid #1B3A8C', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#1B3A8C', fontWeight:600 }}>
                {t.verTodos}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('lecturas')}>
              <span style={{ fontSize:48 }}>📖</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.lecturasSubt}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.lecturasDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.ver}
              </div>
            </div>
          </div>

          <div style={{ marginTop:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>📄 {t.worksheetsTitulo}</h2>
              <button onClick={() => irAPagina('worksheets')}
                style={{ background:'none', border:'1.5px solid #1B3A8C', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#1B3A8C', fontWeight:600 }}>
                {t.verTodos}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('worksheets')}>
              <span style={{ fontSize:48 }}>📄</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.worksheetsSubt}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.worksheetsDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.ver}
              </div>
            </div>
          </div>

          <div style={{ marginTop:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
              <h2 style={{ fontSize:'18px', fontWeight:700 }}>🏆 {t.rankingTitulo}</h2>
              <button onClick={() => irAPagina('ranking')}
                style={{ background:'none', border:'1.5px solid #F59E0B', borderRadius:'8px', padding:'6px 16px', cursor:'pointer', fontSize:'13px', fontFamily:'inherit', color:'#F59E0B', fontWeight:600 }}>
                {t.verRanking}
              </button>
            </div>
            <div style={{ background:'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius:14, padding:20, color:'#fff', display:'flex', alignItems:'center', gap:16, cursor:'pointer', flexWrap:'wrap' }}
              onClick={() => irAPagina('ranking')}>
              <span style={{ fontSize:48 }}>🏆</span>
              <div style={{ flex:1, minWidth:180 }}>
                <div style={{ fontSize:16, fontWeight:800, marginBottom:4 }}>{t.competeTitulo}</div>
                <div style={{ fontSize:13, opacity:.8 }}>{t.competeDesc}</div>
              </div>
              <div style={{ background:'rgba(255,255,255,0.2)', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600 }}>
                {t.ver}
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'80px 20px', gap:'16px', color:'var(--gris-texto)' }}>
        <span style={{ fontSize:'48px' }}>{NAV.find(n => n.id === pagina)?.ic}</span>
        <h2 style={{ fontSize:'22px', fontWeight:700, color:'var(--negro)' }}>{NAV.find(n => n.id === pagina)?.[idioma]}</h2>
        <p style={{ fontSize:'14px' }}>{t.seccionProximamente}</p>
      </div>
    )
  }

  const sidebarStyle = esMovil
    ? {
        width: '260px', background:'var(--azul-oscuro)', padding:'20px 12px',
        display:'flex', flexDirection:'column', gap:'2px', position:'fixed',
        top:0, left:0, height:'100vh', overflowY:'auto', zIndex:1500,
        transform: menuAbierto ? 'translateX(0)' : 'translateX(-100%)',
        transition:'transform .25s ease', boxShadow: menuAbierto ? '4px 0 24px rgba(0,0,0,0.3)' : 'none'
      }
    : {
        width:'220px', background:'var(--azul-oscuro)', padding:'20px 12px',
        display:'flex', flexDirection:'column', gap:'2px', position:'fixed',
        top:0, left:0, height:'100vh', overflowY:'auto'
      }

  return (
    <div style={{ display:'flex', minHeight:'100vh' }}>

      {modalAvatar && (
        <ModalAvatar
          usuario={usuario}
          avatarActualEmoji={stats?.avatar_emoji}
          avatarActualUrl={stats?.avatar_url}
          idioma={idioma}
          onCerrar={() => setModalAvatar(false)}
          onGuardado={() => { setModalAvatar(false); recargarStats() }}
        />
      )}

      {notifInsignia && (
        <div style={{ position:'fixed', top:20, right:20, left: esMovil ? 20 : 'auto', zIndex:9999, background:'linear-gradient(135deg,#92400E,#F59E0B)',
          color:'#fff', borderRadius:16, padding:'16px 20px', boxShadow:'0 8px 32px rgba(0,0,0,0.2)',
          display:'flex', alignItems:'center', gap:12, maxWidth: esMovil ? 'none' : 320, animation:'fadeIn .3s ease both' }}>
          <span style={{ fontSize:36 }}>{notifInsignia.emoji}</span>
          <div>
            <div style={{ fontSize:12, opacity:.8, marginBottom:2 }}>Nueva insignia desbloqueada / New badge unlocked</div>
            <div style={{ fontSize:16, fontWeight:800 }}>{notifInsignia.nombre}</div>
            {notifInsignia.xp_bonus > 0 && (
              <div style={{ fontSize:12, opacity:.8 }}>+{notifInsignia.xp_bonus} XP bonus</div>
            )}
          </div>
          <button onClick={() => setNotifInsignia(null)}
            style={{ background:'none', border:'none', color:'#fff', fontSize:18, cursor:'pointer', marginLeft:'auto' }}>
            ✕
          </button>
        </div>
      )}

      {/* Header movil con boton hamburguesa */}
      {esMovil && (
        <div style={{ position:'fixed', top:0, left:0, right:0, height:56, background:'var(--azul-oscuro)',
          display:'flex', alignItems:'center', gap:12, padding:'0 14px', zIndex:1200, boxShadow:'0 2px 8px rgba(0,0,0,0.15)' }}>
          <button onClick={() => setMenuAbierto(true)}
            style={{ background:'none', border:'none', color:'#fff', fontSize:24, cursor:'pointer', padding:4 }}>
            ☰
          </button>
          <MarcaEspanolGo onClick={() => irAPagina('inicio')} size="small" />
          <div style={{ flex:1 }} />
          <AvatarUsuario avatarUrl={stats?.avatar_url} avatarEmoji={stats?.avatar_emoji} email={usuario?.email} size={30} onClick={() => setModalAvatar(true)} />
        </div>
      )}

      {/* Backdrop oscuro al abrir el menu en movil */}
      {esMovil && menuAbierto && (
        <div onClick={() => setMenuAbierto(false)}
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1400 }} />
      )}

      <aside style={sidebarStyle}>

        <div style={{ padding:'0 8px 16px', borderBottom:'1px solid rgba(255,255,255,.1)', marginBottom:'8px', display:'flex', alignItems:'flex-start', justifyContent:'space-between' }}>
          <div>
            <div style={{ marginBottom:'6px' }}>
              <MarcaEspanolGo onClick={() => irAPagina('inicio')} />
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'3px', marginBottom:'6px' }}>
              {BANDERAS.map((f,i) => <span key={i} style={{ fontSize:'13px' }}>{f}</span>)}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:5 }}>
              <img src="/edunova-logo.png" alt="EduNova" style={{ width:12, height:12, objectFit:'contain', opacity:.7 }} />
              <div style={{ color:'rgba(255,255,255,.4)', fontSize:'10px' }}>{idioma === 'en' ? 'by EDUNOVA' : 'por EDUNOVA'}</div>
            </div>
          </div>
          {esMovil && (
            <button onClick={() => setMenuAbierto(false)}
              style={{ background:'none', border:'none', color:'rgba(255,255,255,.6)', fontSize:20, cursor:'pointer' }}>
              ✕
            </button>
          )}
        </div>

        {/* Selector de idioma ES / EN */}
        <div style={{ padding:'0 8px 14px', marginBottom:'8px', borderBottom:'1px solid rgba(255,255,255,.1)' }}>
          <div style={{ display:'flex', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, overflow:'hidden' }}>
            <button onClick={() => setIdioma('es')}
              style={{ flex:1, padding:'7px 0', border:'none', background: idioma==='es' ? 'var(--naranja)' : 'transparent',
                color: idioma==='es' ? '#fff' : 'rgba(255,255,255,.6)', fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
              🇪🇸 ES
            </button>
            <button onClick={() => setIdioma('en')}
              style={{ flex:1, padding:'7px 0', border:'none', background: idioma==='en' ? 'var(--naranja)' : 'transparent',
                color: idioma==='en' ? '#fff' : 'rgba(255,255,255,.6)', fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
              🇬🇧 EN
            </button>
          </div>
        </div>

        <div style={{ padding:'0 8px 16px', marginBottom:'8px', borderBottom:'1px solid rgba(255,255,255,.1)' }}>
          <AvatarUsuario
            avatarUrl={stats?.avatar_url}
            avatarEmoji={stats?.avatar_emoji}
            email={usuario?.email}
            size={36}
            onClick={() => setModalAvatar(true)}
          />
          <div style={{ fontSize:'12px', color:'rgba(255,255,255,.7)', wordBreak:'break-all' }}>{usuario?.email}</div>
          <div style={{ fontSize:'11px', color:'var(--naranja)', fontWeight:700, marginTop:'2px' }}>
            ⚡ {(stats?.xp_total || 0).toLocaleString()} XP
          </div>
          <button onClick={() => setModalAvatar(true)}
            style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:'10px', cursor:'pointer', padding:0, marginTop:4, textDecoration:'underline' }}>
            {t.cambiarAvatar}
          </button>
        </div>

        {NAV.map(item => (
          <button key={item.id} onClick={() => irAPagina(item.id)}
            style={{ display:'flex', alignItems:'center', gap:'10px', padding:'11px 12px', borderRadius:'10px',
              background: pagina===item.id
                ? item.id==='juegos' ? '#059669'
                : item.id==='worksheets' || item.id==='lecturas' ? '#1B3A8C'
                : item.id==='ranking' || item.id==='insignias' ? '#F59E0B'
                : 'var(--naranja)'
                : 'transparent',
              color: pagina===item.id ? '#fff' : 'rgba(255,255,255,.65)',
              border:'none', fontFamily:'inherit', fontSize:'14px',
              fontWeight: pagina===item.id ? 700 : 500,
              cursor:'pointer', textAlign:'left', width:'100%', transition:'all .15s ease' }}>
            <span style={{ fontSize:'17px' }}>{item.ic}</span>
            <span>{item[idioma]}</span>
          </button>
        ))}

        <div style={{ marginTop:'auto', paddingTop:'16px', borderTop:'1px solid rgba(255,255,255,.08)' }}>
          <button onClick={onLogout}
            style={{ display:'flex', alignItems:'center', gap:'8px', width:'100%', padding:'11px 12px', border:'none', borderRadius:'10px', background:'transparent', color:'rgba(255,255,255,.5)', fontFamily:'inherit', fontSize:'14px', cursor:'pointer', textAlign:'left' }}>
            <span>🚪</span><span>{t.cerrarSesion}</span>
          </button>
        </div>
      </aside>

      <main style={{ flex:1, marginLeft: esMovil ? 0 : '220px', marginTop: esMovil ? 56 : 0, padding: esMovil ? '20px 16px' : '32px', maxWidth:'1200px', width: esMovil ? '100%' : 'auto', boxSizing:'border-box' }}>
        {renderContenido()}
      </main>
    </div>
  )
}
